/**
 * 静态官网路由 - 无需权限校验
 */

import { Navigate } from 'react-router-dom';
import Home from '@/pages/Home';
import FlooringGuide from '@/pages/Academy/FlooringGuide';
import WhatIsHardwoodFlooring from '@/pages/Academy/WhatIsHardwoodFlooring';
import HowHardwoodMade from '@/pages/Academy/HowHardwoodMade';
import BuyingGuide from '@/pages/Academy/BuyingGuide';
import EngineeredVsSolidHardwood from '@/pages/Academy/EngineeredVsSolidHardwood';
import ChoosingWoodSpecies from '@/pages/Academy/ChoosingWoodSpecies';
import GradeAndCharacter from '@/pages/Academy/GradeAndCharacter';
import InstallationConsiderations from '@/pages/Academy/InstallationConsiderations';
import RoomSelection from '@/pages/Academy/RoomSelection';
import FloorCare from '@/pages/Academy/FloorCare';
import Resources from '@/pages/Resources';
import Gallery from '@/pages/Gallery';
import ContactUs from '@/pages/ContactUs';
import AboutUs from '@/pages/AboutUs';
import Products from '@/pages/Products';
import ProductsCollections from '@/pages/Products/Collections';
import ProductsCustom from '@/pages/Products/Custom';
import ProductsDetail from '@/pages/Products/Detail';

// 不配置authName, 代表无权限即可访问
export default [
  {
    path: '/',
    i18nTitle: 'Home',
    component: <Home />,
  },
  {
    path: '/products',
    i18nTitle: 'Products',
    component: <Products />,
    children: [
      {
        i18nTitle: 'Custom',
        path: 'custom',
        component: <ProductsCustom />,
        meta: {
          hideInMenu: true,
        },
      },
      {
        i18nTitle: 'Collection',
        path: ':collectionKey',
        component: <ProductsCollections />,
        meta: {
          hideInMenu: true,
        },
        children: [
          {
            i18nTitle: 'Product',
            path: ':productKey',
            component: <ProductsDetail />,
            meta: {
              hideInMenu: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/academy/hardwood-basics',
    i18nTitle: 'Flooring 101',
    component: <FlooringGuide />,
  },
  {
    path: '/academy/hardwood-basics/what-is-hardwood-flooring',
    i18nTitle: 'What Is Engineered Hardwood?',
    component: <WhatIsHardwoodFlooring />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/hardwood-basics/how-engineered-hardwood-is-made',
    i18nTitle: 'How Engineered Hardwood Is Made',
    component: <HowHardwoodMade />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/floor-care',
    i18nTitle: 'Floor Care & Maintenance',
    component: <FloorCare />,
  },
  {
    path: '/academy/buying-guide',
    i18nTitle: 'Buying Guide',
    component: <BuyingGuide />,
  },
  {
    path: '/academy/buying-guide/engineered-vs-solid-hardwood',
    i18nTitle: 'Engineered Hardwood vs. Solid Hardwood Flooring',
    component: <EngineeredVsSolidHardwood />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/buying-guide/choosing-wood-species',
    i18nTitle: 'Choosing Wood Species',
    component: <ChoosingWoodSpecies />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/buying-guide/grade-and-character',
    i18nTitle: 'Grade and Character',
    component: <GradeAndCharacter />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/buying-guide/installation-considerations',
    i18nTitle: 'Installation Considerations',
    component: <InstallationConsiderations />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/buying-guide/room-selection',
    i18nTitle: 'Choosing Hardwood Flooring Room by Room',
    component: <RoomSelection />,
    meta: {
      hideInMenu: true,
    },
  },
  // Legacy redirects — the Academy section route was renamed from
  // /academy/flooring-guide to /academy/hardwood-basics.
  {
    path: '/academy/flooring-guide',
    i18nTitle: 'Hardwood Basics',
    component: <Navigate to="/academy/hardwood-basics" replace />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/academy/flooring-guide/what-is-hardwood-flooring',
    i18nTitle: 'What Is Engineered Hardwood?',
    component: <Navigate to="/academy/hardwood-basics/what-is-hardwood-flooring" replace />,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: '/resources',
    i18nTitle: 'Resources',
    component: <Resources />,
  },
  {
    path: '/gallery',
    i18nTitle: 'Gallery',
    component: <Gallery />,
  },
  {
    path: '/contact-us',
    i18nTitle: 'Contact Us',
    component: <ContactUs />,
  },
  {
    path: '/about-us',
    i18nTitle: 'About Us',
    component: <AboutUs />,
  },
];
